import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Amplify } from 'aws-amplify'
import App from './App'
import './styles/globals.css'
import { awsConfig, isCognitoConfigured } from './config/aws'
import { ErrorBoundary } from './components/ErrorBoundary'

// Configure Amplify only when Cognito credentials are present to avoid runtime crashes
try {
  if (isCognitoConfigured()) {
    Amplify.configure(awsConfig)
    console.log('✓ Amplify configured with Cognito')
  } else {
    console.warn('⚠ Cognito environment variables not found - running dashboard in demo mode')
  }
} catch (error) {
  console.error('✗ Failed to configure Amplify:', error)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)